import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { roundHours, formatHours } from 'utils/time'

import { Container, Row, Col } from 'react-grid-system'
import moment from 'moment-timezone'

import LeavesAPI from 'api/LeavesAPI'

import styles from './index.css'

const OrangeCommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
    <g fill="none" fillRule="evenodd">
        <path d="M-2-3h24v24H-2z"/>
        <path fill="#F24F12" d="M16.077 17.76l-3.922-3.85H2.309C1.036 13.91 0 12.891 0 11.641V2.267C0 1.017 1.036 0 2.31 0h15.38C18.965 0 20 1.017 20 2.267v9.375c0 1.25-1.036 2.267-2.31 2.267h-.19v3.273c0 .33-.203.63-.514.756a.843.843 0 0 1-.909-.177z"/>
    </g>
  </svg>
)

const BlueCommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18">
    <g fill="none" fillRule="evenodd">
        <path d="M-2-3h24v24H-2z"/>
        <path fill="#0198F9" d="M16.077 17.76l-3.922-3.85H2.309C1.036 13.91 0 12.891 0 11.641V2.267C0 1.017 1.036 0 2.31 0h15.38C18.965 0 20 1.017 20 2.267v9.375c0 1.25-1.036 2.267-2.31 2.267h-.19v3.273c0 .33-.203.63-.514.756a.843.843 0 0 1-.909-.177z"/>
        <g fill="#FFF">
            <path d="M9.23 3h1.538v9H9.23z"/>
            <path d="M14.5 6.73v1.538h-9V6.73z"/>
        </g>
    </g>
  </svg>
)

const TruckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12">
    <g fill="none" fillRule="evenodd">
        <path d="M-1-4h20v20H-1z"/>
        <path fill="#000" d="M17.999 5.727a.447.447 0 0 0-.083-.245L15.102 1.54a.513.513 0 0 0-.415-.207h-3.803c-.276 0-.5.209-.5.467v7.6c0 .257.224.467.5.467h1.023c0 1.178 1.023 2.133 2.285 2.133 1.261 0 2.284-.955 2.284-2.133H17.5c.275 0 .5-.209.5-.467V5.74l-.001-.013zm-5.537-.394V2.667h2.022l2.131 2.666h-4.153zm1.73 5.334c-.572 0-1.038-.45-1.038-1 0-.552.466-1 1.038-1 .573 0 1.039.448 1.039 1 0 .55-.466 1-1.039 1zM9.042 0H.65C.291 0 0 .275 0 .615v8.653c0 .339.29.614.65.614h1.587c0 1.17 1.001 2.118 2.236 2.118 1.235 0 2.237-.948 2.237-2.118h2.333c.359 0 .65-.275.65-.614L9.691.615c0-.34-.29-.615-.65-.615zM4.5 10.667c-.572 0-1.038-.45-1.038-1 0-.552.466-1 1.038-1 .572 0 1.038.448 1.038 1 0 .55-.466 1-1.038 1z"/>
    </g>
  </svg>
)


class Comment extends React.Component {

  static propTypes = {
    comment : PropTypes.string,
    iconStyle : PropTypes.object
  }

  state = { tooltipVisible : false }

  static defaultProps = {
    iconStyle : {}
  }

  render() {
    const { iconStyle } = this.props 
    const iconProps = {}
    if (iconStyle) iconProps.style = iconStyle
    return (
      <div className={styles.CommentContainer}>
        <div className={styles.CommentTooltip} 
          style={{display: this.state.tooltipVisible ? 'block' : 'none'}}>
          {this.props.comment}
        </div>
        {
          this.props.comment ? 
            <div {...iconProps} className={styles.CommentIcon}
              onMouseEnter={() => this.setState({ tooltipVisible: true })}
              onMouseLeave={() => this.setState({ tooltipVisible: false })}
              >
              <OrangeCommentIcon/>
            </div>
          : 
            <div {...iconProps} className={styles.CommentIcon}>
              <BlueCommentIcon/>
            </div>
        }
      </div>
    )
  }
}


const WeeklyPayReportRow = ({leaves, row, ...props}) => {
  let {
    employee_name,
    days,
    comment
  } = row

  days = days.sort((a,b) => a.date >= b.date)
  
  const totalHours = days.reduce((s,v) => s = s + v.hours, 0)
  const truckOverNights = days.reduce((s,v) => s = s + (v.allowances.truck_overnight ? 1 : 0), 0)

  const makeLeave = leave_id => {
    let leave = ''
    if (leave_id) { 
      let l = leaves.find(e => e.id == leave_id)
      if (l) {
        let acronym = l.name.split(' ').map(e => (e.charAt(0)||'').toUpperCase()).join('')
        let color = l.color 
        if (!color.startsWith('#')) color = '#'+color
        leave = <div style={{color}}>{acronym}</div>
      } 
    }
    return leave
  }
  return (
    <Row className={styles.Row} {...props}>
      <Col xs={2} >
        {employee_name}
      </Col>
      {
        days.map(({
          date, hours, manager_comment, leave_id,
          allowances : { truck_overnight, washing }
        }, i) => {
          const s = { textAlign: 'left' }
          if (moment(date).startOf('day').toISOString() == moment(new Date()).startOf('day').toISOString()) {
            s.background = '#fdefeb'
          }
          return (
            <Col key={i} xs={1} style={s}>
              {makeLeave(leave_id)}
              {hours > 0 && <span>{formatHours(hours)}</span>}
              {manager_comment && <Comment iconStyle={{marginLeft: '0.5rem'}} comment={manager_comment}/>}
              {truck_overnight && <div style={{marginLeft: '0.5rem'}}><TruckIcon/></div>}
              {/*<br/>*/}
              {/*washing && 'w'*/}
            </Col>
          )
        })
      }
      <Col xs={1} className={styles.TotalColumn}>
        {formatHours(totalHours)}
      </Col>
      <Col xs={1}>
        {truckOverNights}
      </Col>
      <Col xs={1} className={styles.CommentColumn}>
      { /* skip it for now - jack   <Comment comment={comment} /> */}
      </Col>
    </Row>
  )
}


@withRouter
export default class WeeklyPayReport extends React.Component {
  
  static propTypes = {
    report : PropTypes.object.isRequired,
    leaves : PropTypes.array.isRequired
  }

  static defaultProps = {
    onView : (id) => {},
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { start_date } = this.props.report
    const headerDates = []
    for (let i = 0; i < 7; ++i) {
      headerDates.push(moment(start_date).add('days', i))
    }

    return (
      <Container className={styles.List}>
        <Row className={styles.Header}>
          <Col xs={2}>
            <h2>Name</h2>
          </Col>
          {
            headerDates.map((e,i) => {
              const s = { textAlign: 'left' }
              if (e.startOf('day').toISOString() == moment(new Date()).startOf('day').toISOString()) {
                s.background = '#f1e4e0'
              }
              return (
                <Col key={i} xs={1} style={s}>
                  <h2>
                    {e.format('ddd').toUpperCase()}<br/>
                    {e.format('DD.MM.YY')}
                  </h2>
                </Col>
              )
            })
          }
          <Col xs={1} className={styles.TotalColumn}>
            <h2>Total</h2>
          </Col>
          <Col xs={2}>
            <h2>Truck<br/>overnight</h2>
          </Col>
        </Row>
        {
          (this.props.report.entries || []).map((e, i) =>
            <WeeklyPayReportRow key={i} leaves={this.props.leaves} row={e} />
          )
        }
      </Container>
    )
  }

}



// WEBPACK FOOTER //
// ./src/lists/WeeklyPayReport/index.jsx